module.exports = __webpack_public_path__ + "assets/img/Shape.780a3cfe.png";